import request from '@/util/request';
import qs from 'qs';
// 线下门店管理
export const getList = (params, options) =>
request.get('/api/v4ward/community/merchant/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/community/merchant/detail', Object.assign({}, options, { params }))

export const remove = (params, options) =>
request.post('/api/v4ward/community/merchant/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/community/merchant/save', params,options)

export const update = (params, options) =>
request.post('/api/v4ward/community/merchant/update', params,options)


export const updateStatus = (params, options) =>
  request.post('/api/v4ward/community/merchant/updateStatus', params,options);
